import React, { useEffect, useState } from 'react'
import './NewSlideshow.css'

export default function NewSlideshowP(props) {
    useEffect(() => {
    document.title='Results | UCopenhagen'
    }, []);

    const [activeSlidef, setActiveSlidef] = useState(0)
    function right(index) {
        if (activeSlidef === props.imgURLs.length - 1) {
            setActiveSlidef(activeSlidef => 0)
        }
        else{
            setActiveSlidef(activeSlidef => activeSlidef + 1)}
            
    }
    function left(index) {
        if (activeSlidef === 0) {
            setActiveSlidef(activeSlidef => props.imgURLs.length-1)
        }
        else{
            setActiveSlidef(activeSlidef => activeSlidef - 1)}
    }

    return (
        <div>
            <div style={props.style}>
                {props.imgURLs.map((obj, index) => {
                    return <img
                        style={props.style[activeSlidef]}
                        key={index}
                        src={obj}
                        className={`slideshow-images${activeSlidef === index ? ' active' : ''}`}
                        alt={props.alt}></img>
                })}
                <span className='new-rightarrow' onClick={right}><i className='bi bi-arrow-right-short'></i></span>
                <span className='new-leftarrow' onClick={left}><i className='bi bi-arrow-left-short'></i></span>
                </div>
            <div className={`slideshow-captions-engi`}>{props.caption[activeSlidef]}</div>
        </div>
    )
}